"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterResults = exports["default"] = /*#__PURE__*/function () {
  function FilterResults() {
    _classCallCheck(this, FilterResults);
    _defineProperty(this, "results", null);
    _defineProperty(this, "searchTerm", null);
    _defineProperty(this, "searchType", "subString");
    _defineProperty(this, "searchableColumns", []);
  }
  return _createClass(FilterResults, [{
    key: "setResults",
    value: function setResults(results) {
      this.results = results;
      return this;
    }
  }, {
    key: "setSearchTerm",
    value: function setSearchTerm(searchTerm) {
      this.searchTerm = searchTerm;
      return this;
    }
  }, {
    key: "setSearchType",
    value: function setSearchType(searchType) {
      this.searchType = searchType;
      return this;
    }
  }, {
    key: "setSearchableColumns",
    value: function setSearchableColumns(searchableColumns) {
      this.searchableColumns = searchableColumns;
      return this;
    }
  }, {
    key: "isFilterable",
    value: function isFilterable() {
      return this.searchableColumns.length > 0;
    }
  }, {
    key: "getFilterType",
    value: function getFilterType(item, column) {
      return this.searchTerm.length < 3 || this.searchType === "exact" && item[column].toLowerCase() === this.searchTerm.toLowerCase() || item[column].toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0;
    }
  }, {
    key: "filterItem",
    value: function filterItem(item) {
      var _this = this;
      var match = false;
      this.searchableColumns.forEach(function (column) {
        if (_this.getFilterType(item, column)) {
          match = true;
        }
      });
      return match;
    }
  }, {
    key: "filter",
    value: function filter() {
      var _this2 = this;
      if (this.isFilterable()) {
        this.results = this.results.filter(function (item) {
          return _this2.filterItem(item);
        });
      }
    }
  }]);
}();